export const ErrorIds = {
    NOT_CLAN_MEMBER: 'not_clan_member',
    INTERNAL_ERROR: 'internal_error',
    EXPIRED: 'expired',
}

export const ServerErrorIds = {
    NO_CURRENT_ACTION: 'no_current_action',
    NO_SUCH_PRODUCT: 'no_such_product',
    PRODUCT_CANNOT_PURCHASED: 'product_cannot_purchased',
    PRODUCT_ALREADY_PURCHASED: 'product_already_purchased',
    FAILED_PURCHASE_PRODUCT: 'failed_purchase_product',
    FAILED_SUCCESS_RETRY_TRANSACTION: 'failed_success_retry_transaction',
}



// WEBPACK FOOTER //
// ./containers/ShopView/containers/ShopErrorScreen/constants.js